export const API_ROOT = process.env.REACT_APP_API_ROOT;
export const COOKIE_NAME = "token";
export const STRIPE_PK = process.env.REACT_APP_STRIPE_PK;
export const STRIPE_CLIENT_ID = process.env.REACT_APP_STRIPE_CLIENT_ID;
export const CLIENT_ROOT = process.env.REACT_APP_CLIENT_ROOT;
export const NODE_ENV = process.env.NODE_ENV;
export const AFFILIATE_COOKIE = "affiliate_code";
// Order types.
export const DELIVERY = "delivery";
export const COLLECTION = "collection";
// Statuses.
export const PENDING = "pending";
export const PAID = "paid";
export const CONFIRMED = "confirmed";
export const REJECTED = "rejected";
export const COMPLETED = "completed";
export const DISPATCHED = "dispatched";
export const READY = "ready";
// RGB color values.
export const COLORS = {
	confirmed: [206, 0, 59],
	completed: [98, 206, 24],
	paid: [56, 127, 179],
	pending: [146, 177, 183],
	rejected: [0, 0, 0],
	dispatched: [150, 0, 107],
	ready: [218, 187, 0]
}